<template>
	<div class="shortcut-bar">
		<div class="container">
			<div class="align-center left-part">
				<router-link :to="{ name: 'Home' }" class="welcome">
					<div class="logo flex align-center compact-logo" :data-label="app_name">
						<img :src="app_logo" alt="">
						<div class="logo-name" :title="app_name">{{ app_name }}</div>
					</div>
				</router-link>
				<div class="newsOrder align-center pointer margin-left-40 nav-desktop compact-nav-item" :data-label="$t('简介')" @click="onBriefIntroduction(15)">
					<img src="../../static/images/icon/icon08.png" alt="">
					<div class="nav-label">{{ $t('简介') }}</div>
				</div>

				<div class="right-part nav-mid nav-mid-compact nav-desktop">
					<div class="newsOrder align-center pointer compact-nav-item" :data-label="$t('商品')" @click="onCommodity">
						<img src="../../static/images/icon/icon15.png" alt="">
						<div class="nav-label">{{ $t('商品') }}</div>
					</div>

					<div class="newsOrder align-center pointer compact-nav-item" :data-label="$t('我的订单')" @click="myOrder">
						<img src="../../static/images/icon/icon16.png" alt="">
						<div class="nav-label">{{ $t('我的订单') }}</div>
					</div>

					<div class="newsOrder align-center pointer compact-nav-item" :data-label="$t('购物车')" @click="onCart">
						<img src="../../static/images/icon/icon17.png" alt="">
						<div class="nav-label">{{ $t('购物车') }}</div>
					</div>
				</div>
			</div>

			<div class="right-part nav-mid nav-mid-normal nav-desktop">
				<div class="newsOrder align-center pointer compact-nav-item" :data-label="$t('商品')" @click="onCommodity">
					<img src="../../static/images/icon/icon15.png" alt="">
					<div class="nav-label">{{ $t('商品') }}</div>
				</div>

				<div class="newsOrder align-center pointer compact-nav-item" :data-label="$t('我的订单')" @click="myOrder">
					<img src="../../static/images/icon/icon16.png" alt="">
					<div class="nav-label">{{ $t('我的订单') }}</div>
				</div>

				<div class="newsOrder align-center pointer compact-nav-item" :data-label="$t('购物车')" @click="onCart">
					<img src="../../static/images/icon/icon17.png" alt="">
					<div class="nav-label">{{ $t('购物车') }}</div>
				</div>
			</div>

			<div class="right-part container-box nav-desktop">
				<el-dropdown popper-class="header-language-dropdown" @command="handleCommand" class="newsOrder compact-nav-item" :data-label="$t('语言')">
					<div class="el-dropdown-link">
						<img src="../../static/images/icon/icon04.png" alt="">
						<span class="nav-label">{{ $t('语言') }}</span>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="zh_CN" key="zh_CN">中文</el-dropdown-item>
						<el-dropdown-item command="en_US" key="en_US">English</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<div @click="onUser" class="user-center" v-if="userToken">
					<img :src="user_info.avatar" alt="">
					<div class="user-name">{{ user_info.user_nickname }}</div>
				</div>

				<div class="user-center" v-if="!userToken">
					<router-link :to="{ name: 'Login' }" class="login">
						{{ $t('前去登录') }}
					</router-link>
				</div>

				<div class="newsOrder align-center pointer compact-nav-item" :data-label="$t('通知')" @click="onNews">
					<img src="../../static/images/icon/icon05.png" alt="">
					<div class="nav-label">{{ $t('通知') }}</div>
				</div>

				<div class="newsOrder align-center pointer compact-nav-item" :data-label="$t('关于')" @click="onBriefIntroduction(12)">
					<img src="../../static/images/icon/icon24.png" alt="">
					<div class="nav-label">{{ $t('关于') }}</div>
				</div>
			</div>

			<div class="menu-toggle" @click="navOpen = !navOpen">
				<span :class="{ open: navOpen }"></span>
				<span :class="{ open: navOpen }"></span>
				<span :class="{ open: navOpen }"></span>
			</div>
		</div>

		<div class="mobile-panel" v-show="navOpen">
			<div class="newsOrder align-center pointer" @click="onBriefIntroduction(15); navOpen = false">
				<img src="../../static/images/icon/icon08.png" alt="">
				<div>{{ $t('简介') }}</div>
			</div>
			<div class="newsOrder align-center pointer" @click="onCommodity(); navOpen = false">
				<img src="../../static/images/icon/icon15.png" alt="">
				<div>{{ $t('商品') }}</div>
			</div>
			<div class="newsOrder align-center pointer" @click="myOrder(); navOpen = false">
				<img src="../../static/images/icon/icon16.png" alt="">
				<div>{{ $t('我的订单') }}</div>
			</div>
			<div class="newsOrder align-center pointer" @click="onCart(); navOpen = false">
				<img src="../../static/images/icon/icon17.png" alt="">
				<div>{{ $t('购物车') }}</div>
			</div>
			<div class="newsOrder align-center pointer" @click="openLangPopup">
				<img src="../../static/images/icon/icon04.png" alt="">
				<div>{{ $t('语言') }}</div>
			</div>
			<div @click="onUser(); navOpen = false" class="user-center" v-if="userToken">
				<img :src="user_info.avatar" alt="">
				<div class="user-name">{{ user_info.user_nickname }}</div>
			</div>
			<div class="user-center" v-if="!userToken">
				<router-link :to="{ name: 'Login' }" class="login" @click.native="navOpen = false">
					{{ $t('前去登录') }}
				</router-link>
			</div>
			<div class="newsOrder align-center pointer" @click="onNews(); navOpen = false">
				<img src="../../static/images/icon/icon05.png" alt="">
				<div>{{ $t('通知') }}</div>
			</div>
			<div class="newsOrder align-center pointer" @click="onBriefIntroduction(12); navOpen = false">
				<img src="../../static/images/icon/icon24.png" alt="">
				<div>{{ $t('关于') }}</div>
			</div>
		</div>

		<div class="lang-modal" v-if="langPopupVisible" @click.self="langPopupVisible = false">
			<div class="lang-modal-box">
				<div class="lang-modal-tit">{{ $t('语言') }}</div>
				<div class="lang-option" :class="{ active: currentLocale === 'zh_CN' }" @click="handleCommand('zh_CN')">中文</div>
				<div class="lang-option" :class="{ active: currentLocale === 'en_US' }" @click="handleCommand('en_US')">English</div>
				<div class="lang-cancel" @click="langPopupVisible = false">{{ $t('取消') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getToken } from '@/utils/auth'
	import { userInfo, getconf } from '@/api/user'

	// 缓存页眉 Logo 和站点名称配置，路由切换时无需重复请求。
	let headerAppConfigCache = null;
	// 复用正在进行的配置请求，避免同一时间发起多次请求。
	let headerAppConfigRequest = null;

	export default {
		name: 'ShortcutBar',
		data() {
			return {
				userToken: null,//登录token
				user_info: {},//用户信息
				app_logo: '',//logo
				app_name: '',//名字
				navOpen: false,
				langPopupVisible: false,
			}
		},
		created() {
			this.userToken = getToken()
			let user_info = this.$cookies.get('user_info')
			this.user_info = user_info ? JSON.parse(user_info) : {}
			this.onGetconf()
			// console.log(this.user_info);
			// userInfo()
			// 	.then(ress => {
			// 		// JSON.parse()
			// 		// JSON.stringify()
			// 		this.$cookies.set('user_info', JSON.stringify(ress.data), { expires: 7 }); // 7天后过期
			// 	})
			// console.log(this.userInfo);
		},
		computed: {
			currentLocale() {
				return this.$i18n.locale;
			},
		},
		watch: {
			navOpen(val) {
				this.$nextTick(() => {
					const panel = this.$el.querySelector('.mobile-panel')
					if (!panel) return
					if (val) {
						this.$gsap.fromTo(panel, { height: 0, opacity: 0 }, {
							height: 'auto',
							opacity: 1,
							duration: 0.28,
							ease: 'power2.out',
						})
					}
				})
			},
		},
		mounted() {

		},
		methods: {
			/** 获取并缓存页眉 Logo 和站点名称配置 */
			onGetconf() {
				console.log(headerAppConfigCache)
				if (headerAppConfigCache) {
					this.setHeaderAppConfig(headerAppConfigCache);
					return;
				}

				if (!headerAppConfigRequest) {
					headerAppConfigRequest = Promise.all([
						getconf({ module: 'app' }),
						getconf({ module: 'system' }),
					])
						.then(([appRes, systemRes]) => {
							const appConfig = appRes.code == 1 ? appRes.data : {};
							const systemConfig = systemRes.code == 1 ? systemRes.data : {};
							headerAppConfigCache = {
								app_logo: appConfig.app_logo || '',
								app_name: systemConfig.web_title || '',
							};
							return headerAppConfigCache;
						})
						.catch(() => null)
						.then(data => {
							headerAppConfigRequest = null;
							return data;
						});
				}

				headerAppConfigRequest.then(data => {
					if (data) {
						console.log(data)
						this.setHeaderAppConfig(data);
					}
				});
			},
			/** 将页眉配置显示到页面 */
			setHeaderAppConfig(data) {
				this.app_logo = data.app_logo;
				this.app_name = data.app_name;
			},
			/**消息 */
			onNews() {
				this.$router.push({ name: 'news' });
			},
			/**简介 */
			onBriefIntroduction(i) {
				this.$router.push({ name: 'briefIntroduction', params: { id: i } });
			},
			/**个人资料 */
			onUser() {
				this.$router.push({ name: 'Personaldata', params: { type: 6 } });
			},
			/**商品 */
			onCommodity() {
				this.$router.push({ name: "Search", params: { keyword: '' } });
			},
			/**购物车 */
			onCart() {
				this.$router.push({ name: 'ShoppingCart', params: { type: 1 } });
			},
			/**我的订单 */
			myOrder() {
				this.$router.push({ name: 'MyOrder2', params: { type: 0 } });
			},
			/**我的消息 */
			myInformation() {
				// this.$router.push({ name: 'Personaldata', params: { type: 7 } });
			},
			openLangPopup() {
				this.navOpen = false;
				this.langPopupVisible = true;
			},
			// 语言切换
			handleCommand(e) {
				// console.log(e);
				this.$cookies.set('locale', e, { expires: 7 }); // 7天后过期
				this.$i18n.locale = e;
				window.location.reload();
			},
		}
	};
</script>

<style scoped lang="scss">
	.el-dropdown-link {
		cursor: pointer;
		color: #FFFFFF;
		display: flex;
		align-items: center;

		img {
			margin-right: 6px;
		}

		span {
			font-size: 16px;
			color: #ffffff;
		}
	}

	.el-icon-arrow-down {
		font-size: 16px;
	}

	.user-info {
		float: left;
	}

	/* 快捷导航栏 */
	.shortcut-bar {
		/*margin: 0*/
		width: 100%;
		background-color: #000000;
		font-size: 13px;
		/*color: #12ab34;*/
	}

	.shortcut-bar .container {
		height: 56px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 var(--page-gutter);
		box-sizing: border-box;

		.logo {
			color: #fff;

			img {
				width: 32px;
				height: 32px;
				margin-right: 8px;
				object-fit: cover;
				object-position: center;
				cursor: pointer;

				@media (min-width: 768px) {
					width: 35px;
					height: 35px;
					margin-right: 12px;
				}
			}
		}

		.logo-name {
			font-size: 15px;
			max-width: 140px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;

			@media (min-width: 768px) {
				font-size: 18px;
				max-width: 220px;
			}
		}
	}

	.left-part {
		height: 100%;
		min-width: 0;
	}

	.menu-toggle {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 28px;
		height: 28px;
		cursor: pointer;
		flex-shrink: 0;

		span {
			display: block;
			height: 2px;
			background: #fff;
			margin: 3px 0;
			transition: transform 0.25s ease, opacity 0.25s ease;
		}

		@media (min-width: 1280px) {
			display: none;
		}
	}

	.nav-desktop {
		display: none !important;

		@media (min-width: 1280px) {
			display: flex !important;
		}
	}

	.nav-mid {
		width: 20vw;
		flex-shrink: 0;
		justify-content: space-between;

		.newsOrder {
			font-size: 18px;
		}
	}

	/* 默认使用页眉中间导航，紧凑 PC 模式再切换到简介旁边的导航组。 */
	.nav-mid-compact {
		display: none !important;
	}

	/* 紧凑 PC 模式隐藏导航文字，悬停图标时展示名称，避免英文导航互相遮挡。 */
	@media (min-width: 1280px) and (max-width: 1599px) {
		.nav-mid-normal {
			display: none !important;
		}

		.nav-mid-compact {
			display: flex !important;
		}

		.compact-nav-item {
			position: relative;
			justify-content: center;
			width: 28px;
			height: 36px;

			img {
				margin-right: 0;
			}

			.nav-label {
				display: none;
			}

			&::after {
				content: attr(data-label);
				position: absolute;
				top: calc(100% + 6px);
				left: 50%;
				transform: translate(-50%, -4px);
				z-index: 50;
				padding: 7px 10px;
				border: 1px solid rgba(255, 255, 255, .16);
				border-radius: 6px;
				background: rgba(30, 30, 30, .96);
				box-shadow: 0 6px 16px rgba(0, 0, 0, .28);
				color: #fff;
				font-size: 13px;
				font-weight: 500;
				line-height: 18px;
				white-space: nowrap;
				opacity: 0;
				visibility: hidden;
				pointer-events: none;
				transition: opacity .18s ease, transform .18s ease, visibility .18s ease;
			}

			&:hover::after {
				opacity: 1;
				visibility: visible;
				transform: translate(-50%, 0);
			}
		}

		.compact-logo {
			position: relative;

			img {
				margin-right: 0 !important;
			}

			.logo-name {
				display: none;
			}

			&::after {
				content: attr(data-label);
				position: absolute;
				top: calc(100% + 6px);
				left: 50%;
				transform: translate(-50%, -4px);
				z-index: 50;
				max-width: 260px;
				overflow: hidden;
				text-overflow: ellipsis;
				padding: 7px 10px;
				border: 1px solid rgba(255, 255, 255, .16);
				border-radius: 6px;
				background: rgba(30, 30, 30, .96);
				box-shadow: 0 6px 16px rgba(0, 0, 0, .28);
				color: #fff;
				font-size: 13px;
				font-weight: 500;
				line-height: 18px;
				white-space: nowrap;
				opacity: 0;
				visibility: hidden;
				pointer-events: none;
				transition: opacity .18s ease, transform .18s ease, visibility .18s ease;
			}

			&:hover::after {
				opacity: 1;
				visibility: visible;
				transform: translate(-50%, 0);
			}
		}

		.left-part .compact-nav-item {
			margin-left: 24px !important;
		}

		/* 中间商品导航使用统一图标按钮，避免三个图标在宽容器内显得松散。 */
		.nav-mid {
			width: 156px;
			justify-content: space-between;

			.compact-nav-item {
				width: 38px;
				height: 38px;
				border: 1px solid rgba(255, 255, 255, .18);
				border-radius: 10px;
				background: rgba(255, 255, 255, .06);
				transition: background .18s ease, border-color .18s ease, transform .18s ease;

				img {
					width: 19px;
					height: 19px;
					margin-right: 0;
				}

				&:hover {
					border-color: rgba(255, 255, 255, .48);
					background: rgba(255, 255, 255, .16);
					transform: translateY(-1px);
				}
			}
		}
	}

	.mobile-panel {
		display: flex;
		flex-direction: column;
		background: #111;
		padding: 8px var(--page-gutter) 16px;
		gap: 14px;
		overflow: hidden;

		.newsOrder,
		.user-center,
		.login {
			font-size: 16px;
			color: #fff;
		}

		.user-center {
			display: flex;
			align-items: center;
			flex-direction: row;
		}

		@media (min-width: 1280px) {
			display: none !important;
		}
	}

	.shortcut-bar .welcome {
		display: flex;
		align-items: center;
		/*width: 120px;*/
		height: 100%;
		/*background-color: red;*/
		vertical-align: 12px;
		cursor: pointer;
	}

	/* 地址 */
	.shortcut-bar .address {
		display: inline-block;
		position: relative;
		/*padding: 0 18px;*/
		width: 44px;
		height: 30px;
		/*border: none;*/
		z-index: 20;
	}

	.shortcut-bar .address .current-address {
		display: inline-block;
		position: absolute;
		top: -1.5px;
		left: 0;
		width: 100%;
		height: 29px;
		/* // line-height: 30px; */
		border-top: none;
		z-index: 20;
		padding-left: 25px;
		border: 1px solid #eee;
		border-top: none;
		background: url('../assets/app-header/icons/address.png') no-repeat;
		background-position: 5px 6px;
		background-size: 16px 16px;
	}

	.shortcut-bar .address:hover .current-address {
		color: #12ab34;
		background-image: url('../assets/app-header/icons/address-active.png');
	}

	.shortcut-bar .address:hover .current-address {
		background-color: #fff;
		border-bottom: 2px solid #fff;
		border-left: 1px solid #999;
		border-right: 1px solid #999;
		/*background-image: url('../assets/address-active.png');
		color: #12ab34;
		cursor: pointer;*/
	}

	.shortcut-bar .address .address-selected-bar {
		position: absolute;
		width: 300px;
		top: 28px;
		left: 0;
		padding: 10px;
		border: 1px solid #999;
		background-color: #fff;
		z-index: 1;
	}

	.shortcut-bar .address .address-selected-bar ul {
		overflow: hidden;
		/*background-color: red;*/
	}

	.shortcut-bar .address .address-selected-bar .all-city {
		border-top: 1px solid #999;
		margin-top: 10px;
		padding-top: 10px;
	}

	.shortcut-bar .address .address-selected-bar li {
		float: left;
		list-style: none;
		width: 44px;
		padding-left: 16px;
		height: 30px;
		/*background-color: red;*/
	}

	.shortcut-bar .address-selected-bar ul>li:hover {
		color: #12ab34;
		cursor: pointer;
		background-color: #eee;
	}

	/* 快捷导航栏右侧 */
	.shortcut-bar .right-part {
		/*display: inline-block;*/
		float: right;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.container-box {
		width: auto;
		max-width: 476px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 16px;
	}

	.shortcut-bar .right-part>li {
		float: left;
		padding: 0 10px;
	}

	.shortcut-bar .right-part>li:first-child:hover,
	.shortcut-bar .right-part>li:nth-child(2):hover,
	.shortcut-bar .right-part .user-center>div:hover,
	.shortcut-bar .right-part .business-cooperation>span:hover,
	.shortcut-bar .right-part .app-qrcode>span:hover,
	.shortcut-bar .right-part>li>ul>li:hover {
		color: #FFFFFF;
		cursor: pointer;
	}

	.user-center>img {
		width: 38px;
		height: 38px;
		display: block;
		margin-right: 8px;
		border-radius: 40px;
		object-fit: cover;
		object-position: center;
		cursor: pointer;
	}

	.newsOrder {
		display: flex;
		color: #fff;
		font-size: 16px;

		@media (min-width: 1440px) {
			font-size: 18px;
		}

		img {
			width: 20px;
			height: 20px;
			margin-right: 8px;
			display: block;
		}

		.my-news,
		.my-order {
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		.my-news {
			padding-right: 16px;
		}

		.my-order {
			padding-left: 16px;
			border-left: 1px solid #d9d9d9;
		}
	}

	/* .shortcut-bar .right-part>li>ul>li:hover {
		background-color: #eee;
	} */

	.shortcut-bar .right-part>li>ul>li {
		position: relative;
		/*border: 1px solid red;*/
	}

	.shortcut-bar .right-part>li>ul>li .item-number {
		color: #fff;
		font-size: 12px;
		font-weight: bold;
		display: inline-block;
		width: 18px;
		height: 16px;
		/* // line-height: 16px; */
		text-align: center;
		background-color: #12ab34;
		border-radius: 50%;
		margin-left: 5px;
	}

	.user-center {
		/* // margin-right: 64px; */
		color: #FFFFFF;
		display: flex;
		align-items: center;
		flex-direction: row;
	}

	.user-center .user-name {
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	/* 用户中心 & 商务合作 & 手机生鲜*/
	.shortcut-bar .right-part .user-center,
	.shortcut-bar .right-part .business-cooperation,
	.shortcut-bar .right-part .app-qrcode {
		display: flex;
		align-items: center;
		/* width: 52px; */
		height: 30px;
		/* position: relative; */
		z-index: 20;
	}

	.shortcut-bar .right-part .user-center>span,
	.shortcut-bar .right-part .business-cooperation>span,
	.shortcut-bar .right-part .app-qrcode>span {
		box-sizing: border-box;
		display: inline-block;
		width: 100%;
		text-align: center;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 20;
	}

	.shortcut-bar .right-part .user-center:hover>span,
	.shortcut-bar .right-part .business-cooperation:hover>span,
	.shortcut-bar .right-part .app-qrcode:hover>span {
		background-color: #fff;
		border-bottom: 1px solid #fff;
		border-left: 1px solid #999;
		border-right: 1px solid #999;
		z-index: 20;
	}

	.shortcut-bar .right-part .user-center ul,
	.shortcut-bar .right-part .business-cooperation ul {
		box-sizing: border-box;
		border: 1px solid #999;
		position: absolute;
		top: 29px;
		left: 0px;
		width: 110px;
		padding: 0px 10px;
		background-color: #fff;
	}

	.shortcut-bar .right-part .app-qrcode div {
		text-align: center;
		box-sizing: border-box;
		border: 1px solid #999;
		position: absolute;
		top: 29px;
		right: 0px;
		/*height: 100px;*/
		padding: 10px 10px 0 10px;
		background-color: #fff;
	}

	.shortcut-bar .right-part .app-qrcode div img {
		width: 140px;
		height: 140px;
	}

	/**登录按钮 */
	.login {
		color: #fff;
	}

	.lang-modal {
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, .5);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 2000;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.lang-modal-box {
		width: 280px;
		padding: 24px 20px 16px;
		background-color: #fff;
		border-radius: 16px;
		text-align: center;
		box-sizing: border-box;
	}

	.lang-modal-tit {
		font-size: 18px;
		font-weight: bold;
		color: #333;
		margin-bottom: 16px;
	}

	.lang-option {
		height: 44px;
		line-height: 44px;
		font-size: 16px;
		color: #333;
		border-radius: 8px;
		cursor: pointer;
	}

	.lang-option.active {
		background: #000;
		color: #fff;
	}

	.lang-cancel {
		margin-top: 12px;
		height: 40px;
		line-height: 40px;
		font-size: 15px;
		color: #666;
		cursor: pointer;
	}
</style>

<style lang="scss">
/* PC 页眉语言下拉菜单悬停样式 */
.header-language-dropdown {
	.el-dropdown-menu__item {
		&:not(.is-disabled):hover,
		&:not(.is-disabled):focus {
			color: #000000;
			background: #F5F5F5;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ShortcutBar.vue